// extracted by mini-css-extract-plugin
export default {"root":"sgkZ4jl0LvNdfmqsNH7z","title":"oS9ojEvNQwqBRWht3fL_","body":"nJsiznKzHtWS_O645B_L","copy":"GKlTKTKhJG9vo2GDqT4Y","footer":"a0_70PQUbeLvP5XuAxTa","link":"QcqzmnXURbkVoTjWtZpN"};